// extracted by mini-css-extract-plugin
export default {"bg":"FM3UqBURiJqkjC4tI7eS"};